import { avatarToneClassName, projectAvatarSeed, projectInitial } from "@/lib/avatar"
import { cn } from "@/lib/utils"

export type ProjectThumbProject = { id: number; name: string; cover_url: string | null }

export function ProjectThumb({ project, className }: { project: ProjectThumbProject; className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        "relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-lg leading-none font-semibold select-none",
        !project.cover_url && avatarToneClassName(projectAvatarSeed(project.id)),
        className,
      )}
    >
      {project.cover_url ? (
        <img src={project.cover_url} alt="" loading="lazy" className="size-full object-cover" />
      ) : (
        projectInitial(project.name)
      )}
    </span>
  )
}
